import { Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";

import { ConsultasOperacaoScrDTO, LabelSituacaoConsultaOperacaoScr, LabelTipoConsultaOperacaoScr } from "src/app/model/consulta-ipoc.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ROLE_AGENTE_CONSULTA} from "src/app/constantes/permissao.constants";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import Utils from "src/app/shared/fgi-utils";



@Component({
    selector: 'app-aba-consulta-bacen',
    templateUrl: './aba-consulta-bacen.component.html',
    styleUrls: ['./aba-consulta-bacen.component.scss'],
    standalone: false
})
export class AbaConsultaBacenComponent implements OnInit, OnChanges {

  @Input() public consultasOperacaoScr: ConsultasOperacaoScrDTO[] = [];
  @Input() public atributosPaginacaoAbaConsultaBacen: EntityPagedRequestParameters;
  @Input() public opcoesPaginacaoAbaConsultaBacen: number[];
  
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public countConsulta: number;
  public listaConsulta: ConsultasOperacaoScrDTO[];
  private isAgente: boolean;
 
  constructor(private permissaoService: PermissaoService){
  }

  ngOnInit(): void {

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.isAgente = resp && resp[ROLE_AGENTE_CONSULTA];
    });

    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'  
    }
   
  }

  ngOnChanges(changes: SimpleChanges): void{

    this.navegar(this.atributosPaginacaoAbaConsultaBacen);
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {

    this.atributosPaginacaoAbaConsultaBacen = novaPagina;
    this.navegar(this.atributosPaginacaoAbaConsultaBacen);
  }

  navegar(pesq: EntityPagedRequestParameters) {

    let posInicial: number, posFinal: number;

    posInicial = (pesq.page-1) * pesq.pageSize;
    posFinal = posInicial + pesq.pageSize;

    if (posFinal > this.consultasOperacaoScr.length) {
      posFinal = this.consultasOperacaoScr.length;
    }

    this.listaConsulta = this.consultasOperacaoScr.slice(posInicial,posFinal);
    this.countConsulta = this.consultasOperacaoScr.length;
  }

  retornaLabelSituacao(situacaoConsulta):string{ 
    return LabelSituacaoConsultaOperacaoScr.filter(e=>e.codigo==situacaoConsulta)[0].nome;
  }

  retornaLabelTipoConsulta(tipoAcao: string):string{ 
    return LabelTipoConsultaOperacaoScr.get(tipoAcao);
  }
  

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacaoConsulta(this.atributosOrdenacao);
  }

  pesquisarOrdenacaoConsulta(ord: EntityOrderedRequestParameters) {
    this.listaConsulta = this.listaConsulta.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.compara(a, b, ord.atributo);
      }
      else {
        return -1 * Utils.compara(a, b, ord.atributo);
      }
    });
  }
}



